import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { supabase } from '@/lib/supabase';
import { AuthConfirmation } from '@/components/desktop/auth/AuthConfirmation';

export function DesktopAuthConfirmPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEmailConfirmation = async () => {
      try {
        // 모바일 로직 재사용 - Supabase가 자동으로 URL 파라미터를 처리하고 세션을 설정합니다
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth confirmation error:', error);
          navigate('/login', { replace: true });
          return;
        }

        if (session) {
          console.log('Email confirmed successfully');
          // 인증이 완료되었으므로 로그아웃 후 로그인 페이지로 이동
          await supabase.auth.signOut();
          navigate('/login', { 
            replace: true,
            state: { message: '이메일 인증이 완료되었습니다. 로그인해주세요.' }
          });
        } else {
          // 세션이 없으면 로그인 페이지로
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('Auth confirm error:', error);
        navigate('/login', { replace: true });
      }
    };

    // Supabase가 URL 파라미터를 처리할 시간을 주기 위해 약간의 지연
    setTimeout(handleEmailConfirmation, 1000);
  }, [navigate]);

  return (
    <DesktopLayout>
      <div className="min-h-[80vh] flex items-center justify-center py-12">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg border border-gray-200 px-10 py-16">
          
          {/* Auth Confirmation Section - SRP: 인증 처리 상태 표시만 담당 */}
          <AuthConfirmation />
          
        </div>
      </div>
    </DesktopLayout>
  );
}